<script setup>
// import Icond from '../Icon.vue';
import { Icon } from '@iconify/vue';
import { isMenuItemNew } from '@/config/menu';
import { useAuthStore } from '@/stores/authStore';
const props = defineProps({ item: Object, level: Number });
const auth = useAuthStore();
</script>

<template>
    <!---Single Item-->
    <div class="mb-1">
        <!-- Link externo -->
        <a
            v-if="item.type === 'external' || (item.to && (item.to.startsWith('http://') || item.to.startsWith('https://')))"
            :href="item.to"
            target="_blank"
            rel="noopener noreferrer"
            :class="'v-list-item v-list-item--link bg-hover-' + item.BgColor + ' rounded-lg'"
            style="text-decoration: none; display: flex; align-items: center; min-height: 38px; padding: 0; cursor: pointer"
        >
            <!---If icon-->
            <div :class="'navbox  bg-hover-' + item.BgColor" :color="item.BgColor" style="margin-right: 12px">
                <span class="icon-box">
                    <Icon
                        :icon="item.icon && item.icon.includes(':') ? item.icon : 'solar:' + item.icon"
                        height="24"
                        width="24"
                        :level="level"
                        :class="'position-relative z-index-2 texthover-' + item.BgColor"
                    />
                </span>
            </div>
            <div style="flex: 1; display: flex; flex-direction: column; justify-content: center; min-width: 0">
                <span class="text-subtitle-1 font-weight-medium" :class="'text-' + item.BgColor">{{ $t(item.title) }}</span>
                <!---If Caption-->
                <span v-if="item.subCaption" class="text-caption mt-n1 hide-menu">{{ item.subCaption }}</span>
            </div>
            <!---If any chip or label-->
            <v-chip
                v-if="item.chip"
                :color="item.chipColor"
                class="sidebarchip hide-menu"
                :size="item.chipIcon ? 'x-small' : 'x-small'"
                :variant="item.chipVariant"
                :prepend-icon="item.chipIcon"
            >
                {{ item.chip }}
            </v-chip>
        </a>
        <!-- Link interno (router-link) -->
        <v-list-item
            v-else
            :to="item.to"
            rounded
            :class="'  bg-hover-' + item.BgColor + (item.active ? ' v-list-item--active custom-active' : ' custom-inactive')"
            :color="item.BgColor"
            :ripple="false"
            :disabled="item.disabled"
            v-scroll-to="{ el: '#top' }"
            :active="item.active"
        >
            <!---If icon-->
            <template v-slot:prepend>
                <div :class="'navbox  bg-hover-' + item.BgColor" :color="item.BgColor">
                    <span class="icon-box">
                        <Icon
                            :icon="item.icon && item.icon.includes(':') ? item.icon : 'solar:' + item.icon"
                            height="24"
                            width="24"
                            :level="level"
                            :class="'position-relative z-index-2 texthover-' + item.BgColor"
                        />
                    </span>
                </div>
            </template>
            <v-list-item-title class="text-subtitle-1 font-weight-medium d-flex align-center" :color="item.BgColor" style="gap:8px">
                <span class="text-truncate" style="flex:1 1 auto;min-width:0">{{ $t(item.title) }}</span>
                <span v-if="isMenuItemNew(item, auth.user?.first_login_at)" class="menu-new-flag" style="margin-left:auto" title="Módulo novo">New</span>
            </v-list-item-title>
            <!---If Caption-->
            <v-list-item-subtitle v-if="item.subCaption" class="text-caption mt-n1 hide-menu">
                {{ item.subCaption }}
            </v-list-item-subtitle>
            <!---If any chip or label-->
            <template v-slot:append v-if="item.chip">
                <v-chip
                    :color="item.chipColor"
                    class="sidebarchip hide-menu"
                    :size="item.chipIcon ? 'x-small' : 'x-small'"
                    :variant="item.chipVariant"
                    :prepend-icon="item.chipIcon"
                >
                    {{ item.chip }}
                </v-chip>
            </template>
        </v-list-item>
    </div>
</template>

<style scoped>
/* Sobrescrever detecção automática do Vue Router/Vuetify quando item.active é false */
.custom-inactive.v-list-item--active:not(.custom-active) {
    background-color: transparent !important;
    color: inherit !important;
}

.custom-inactive.v-list-item--active :deep(.v-list-item-title) {
    color: inherit !important;
}
/* Etiqueta "New" de módulo recém-lançado (some sozinha após newUntil). */
.menu-new-flag {
    display: inline-flex;
    align-items: center;
    flex-shrink: 0;
    font-size: 0.6rem;
    font-weight: 800;
    letter-spacing: 0.4px;
    text-transform: uppercase;
    color: #fff;
    background: #0a9981;
    border-radius: 999px;
    padding: 1px 7px;
    line-height: 1.5;
}
</style>
